import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    OpacityInAnimation,
    OpacityOutAnimation,
    PrologueComponent,
    LoadingSlateComponent,
    StickyDirective,
} from '@exl-ng/mulo-common';

import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { IndexPageService } from './index-page.service';
import { SEOService } from '../core/seo.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatFabAnchor } from '@angular/material/button';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { KeyValuePipe } from '@angular/common';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

@Component({
    selector: 'esp-index-page',
    templateUrl: './index-page.component.html',
    styleUrls: ['./index-page.component.scss'],
    animations: [OpacityInAnimation, OpacityOutAnimation],
    imports: [
        PrologueComponent,
        CenteredBlockLayoutComponent,
        MatIcon,
        SvgViewboxDirective,
        LoadingSlateComponent,
        RouterLink,
        StickyDirective,
        MatFabAnchor,
        KeyValuePipe,
        TranslateModule,
    ],
})
export class IndexPageComponent {
    private configService = inject(ConfigurationHandlerService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private indexPageService = inject(IndexPageService);
    private seoService = inject(SEOService);
    private t = inject(TranslateService);

    indexKey: string;
    indexData: { [key: string]: string[] };
    indexIdx: string;
    delimiter = '____^____^____';

    bttStuck = false;
    loading = true;

    constructor() {
        const route = this.route;
        const router = this.router;
        const seoService = this.seoService;
        const t = this.t;

        route.data.subscribe((routeData) => {
            this.indexKey = routeData.indexKey;
            this.indexPageService
                .getSEOFileIndexByName(this.indexKey)
                .subscribe((data) => {
                    this.indexData = data as { [key: string]: string[] };
                    const idxParam = route.snapshot.params?.['idx'];
                    if (!(this.indexData[idxParam]?.length > 0)) {
                        const firstRealIdx = Object.keys(this.indexData)
                            .sort()
                            .find((key) => this.indexData[key]?.length > 0);

                        if (firstRealIdx) {
                            router.navigate(['../', firstRealIdx], {
                                relativeTo: route,
                                queryParamsHandling: 'preserve',
                                replaceUrl: true,
                            });
                        }
                    }
                    this.loading = false;
                });

            const pageTitle =
                'esploro.research.conf.research.portal.label.prefix.' +
                (this.indexKey === 'researchersIndex'
                    ? 'profileIndexLink'
                    : 'portalIndexLink');
            t.get(pageTitle).subscribe((_) => seoService.updatePageTitle(_));
        });
        route.params.subscribe((params) => (this.indexIdx = params['idx']));
    }
}
